// Chakra imports
import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Text,
  Modal,
  ModalOverlay,
  ModalHeader,
  ModalBody,
  ModalContent,
  ModalFooter,
  useColorModeValue,
  Center,
  Grid,
  Box,
  useToast,
  GridItem,
} from "@chakra-ui/react";
import { CheckIcon, InfoIcon, QuestionIcon } from '@chakra-ui/icons';
// Custom components
import Card from "components/card/Card.js";
import React, { useState, useRef } from "react";
import axios from "axios";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import SignaturePad from 'react-signature-pad-wrapper';
import { decryptData, URL_WEB_BACKEND } from "CustomUtil";

export default function AddSuma({ onRefresh }) {
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));
  const namanya = decryptData(localStorage.getItem("authfullnamesemakinpas"));
  const userid = decryptData(localStorage.getItem("authidsemakinpas"));
  const [titleDialog, setTitleDialog] = useState('title');
  const [descDialog, setDescDialog] = useState('desc');
  const [statusInfoDialog, setStatusInfoDialog] = useState(false);
  const [infoDialogIcon, setInfoDialogIcon] = useState(1);
  const [statusConfExeDialog, setStatusConfExeDialog] = useState(false);
  const signaturePadReff = useRef();
  const toast = useToast();

  // add
  const [isisurat, setIsisurat] = useState('');
  const [lampiran, setLampiran] = useState(0);
  const [tanggalsurat, setTanggalsurat] = useState(new Date());
  const [dari, setDari] = useState('');
  const [pengoleh, setPengoleh] = useState('');
  const [filesurat, setFilesurat] = useState(null);
  const [nosurat, setNosurat] = useState('');

  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";

  const confAdd = () => {
    if (nosurat === '' || isisurat === '' || lampiran === '' || dari === '' || pengoleh === '' || signaturePadReff.current.isEmpty()) {
      toast({
        status: 'error',
        title: 'Proses Gagal',
        description: 'Masih ada kolom yang kosong',
        position: 'bottom-right',
        isClosable: true,
      })
    } else { showConfExeDialog('Input Surat Masuk', 'Simpan data surat masuk?') }
  }

  function makeVerifId(length) {
    var result = '';
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return result;
  }

  const exeAdd = async () => {
    setStatusConfExeDialog(false);
    const formData = new FormData();
    formData.append('tanggal', new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60 * 1000).toJSON().slice(0, 19).replace('T', ' '))
    formData.append('nosurat', nosurat.toUpperCase().replace(/\s+/g, ""))
    formData.append('tanggalsurat', new Date(tanggalsurat.getTime() - tanggalsurat.getTimezoneOffset() * 60 * 1000).toJSON().slice(0, 19).replace('T', ' '))
    formData.append('isisurat', isisurat)
    formData.append('lampiran', lampiran)
    formData.append('dari', dari)
    formData.append('id_user', parseInt(userid))
    formData.append('akun', namanya)
    formData.append('pengoleh', namanya + ' - ' + pengoleh)
    formData.append('paraf', signaturePadReff.current.toDataURL())
    formData.append('verifid', makeVerifId(30) + userid)
    formData.append('disposisike', '')
    formData.append('isidisposisi', '')
    if (filesurat != null) {
      formData.append('filesurat', filesurat)
    }
    await axios.post(URL_WEB_BACKEND + '/sumas', formData, {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then(res => {
      if (res.status === 201) {
        showInfoDialog('Surat Masuk Berhasil Disimpan Untuk Diajukan Disposisi', 'Mohon Perbarui Kembali Setelah Disposisi Sudah Turun', 0);
      } else {
        let reskey = Object.keys(res.response.data.messages)[0];
        showInfoDialog('Error Input surat masuk dengan status ' + res.response.status, res.response.messages[reskey], 1)
      }
    }).catch(err => {
      let errkey = Object.keys(err.response.data.messages)[0];
      showInfoDialog('Error Input surat masuk dengan status ' + err.response.status, err.response.data.messages[errkey], 1)
    })
  }

  function showInfoDialog(title, desc, infoicon) {
    setTitleDialog(title); setDescDialog(desc); setInfoDialogIcon(infoicon); setStatusInfoDialog(true);
  }

  function showConfExeDialog(title, desc) {
    setTitleDialog(title); setDescDialog(desc); setStatusConfExeDialog(true);
  }

  const viewInfoDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusInfoDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>{titleDialog}</ModalHeader>
          <ModalBody>
            <Center>
              {infoDialogIcon
                ? <InfoIcon w={16} h={16} color="blue.500" />
                : <CheckIcon w={16} h={16} color="green.500" />
              }
            </Center>
            <Center mt={8}>
              <Text fontSize='large'>{descDialog}</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => { signaturePadReff.current.clear(); setStatusInfoDialog(false); setFilesurat(null); onRefresh(); }}>OK</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  const viewConfExeDialog = () => {
    return (
      <Modal closeOnOverlayClick={true} isCentered isOpen={statusConfExeDialog}>
        <ModalOverlay
          bg='blackAlpha.300'
          backdropFilter='blur(10px) hue-rotate(10deg)'
        />
        <ModalContent>
          <ModalHeader>{titleDialog}</ModalHeader>
          <ModalBody>
            <Center><QuestionIcon w={16} h={16} color="blue.500" /></Center>
            <Center mt={8}>
              <Text fontSize='large'>{descDialog}</Text>
            </Center>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme='red' mr={3} onClick={() => exeAdd()}>
              Iya, Lanjutkan
            </Button>
            <Button onClick={() => { setStatusConfExeDialog(false) }}>Batal</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    )
  }

  return (
    <Card align='center' p='20px'>
      <Flex h='100%' direction={{ base: "column", "2xl": "row" }}>
        <Flex direction='column' pe='44px'>
          {viewInfoDialog()}{viewConfExeDialog()}
          <Text
            color={textColorPrimary}
            fontWeight='bold'
            textAlign='start'
            fontSize='2xl'
            mt={{ base: "5px", "2xl": "5px" }}>
            Input Surat Masuk
          </Text>
          <Text
            color={textColorSecondary}
            fontSize='md'
            my={{ base: "auto", "2xl": "10px" }}
            textAlign='start'>
            Untuk diajukan disposisi.
          </Text>
          <Flex w="100%" direction="column" align="stretch">
            <FormControl id="profil" isRequired w="100%">
              <Grid templateColumns="repeat(5, 2fr)" gap={5} w="100%">
                <GridItem colSpan={4}>
                  <Box w="100%">
                    <FormLabel>Nomor Surat</FormLabel>
                    <Input id={"add" + 0 + 1} placeholder="Masukkan nomor surat" borderRadius="16px" value={nosurat} onChange={(e) => setNosurat(e.target.value)} />
                    <FormLabel>Isi Ringkas</FormLabel>
                    <Input id={"add" + 0 + 2} placeholder="Masukkan isi surat secara ringkas" borderRadius="16px" value={isisurat} onChange={(e) => setIsisurat(e.target.value)} />
                    <FormLabel>Lampiran</FormLabel>
                    <Input type='number' min={0} id={"add" + 0 + 2} placeholder="Masukkan jumlah lampiran" borderRadius="16px" value={lampiran} onChange={(e) => setLampiran(e.target.value)} />
                    <FormLabel>Tanggal Surat</FormLabel>
                    <SingleDatepicker
                      name="date-input"
                      date={tanggalsurat}
                      onDateChange={setTanggalsurat}
                    />
                    <FormLabel>Asal Surat & Media Pengiriman</FormLabel>
                    <Input id={"add" + 0 + 3} placeholder="Contoh : Kanwil Ditjenpas Jateng - Srikandi" borderRadius="16px" value={dari} onChange={(e) => setDari(e.target.value)} />
                    <FormControl id={"add" + 0 + 2}>
                      <FormLabel>File Surat</FormLabel>
                      <Input variant='main' h='100' mb='5' border='2px dashed' type='file' id={"uploadfile" + 0 + 5} placeholder="Pilih file surat" borderRadius="16px" onChange={(e) => setFilesurat(e.target.files[0])} />
                    </FormControl>
                  </Box>
                </GridItem>
                <GridItem colSpan={1}>
                  <Box w="100%">
                    <FormLabel>Akun</FormLabel>
                    <Input id={"add" + 0 + 6} borderRadius="16px" value={namanya} disabled />
                    <FormLabel>Pengoleh</FormLabel>
                    <Input id={"add" + 0 + 7} placeholder="Masukkan nama pengoleh" borderRadius="16px" value={pengoleh} onChange={(e) => setPengoleh(e.target.value)} />
                    <FormLabel>Paraf</FormLabel>
                    <Box border='2px dashed' borderRadius="16px" borderColor='gray.300'>
                      <SignaturePad ref={signaturePadReff} />
                      <Button mb='2' onClick={() => signaturePadReff.current.clear()}>Ulangi Paraf</Button>
                    </Box>
                  </Box>
                </GridItem>
                <GridItem colSpan={4}>
                  <Box w="100%">
                    <Button w='100%' colorScheme='red' mt={4} onClick={() => { setNosurat(''); setIsisurat(''); setLampiran(0); setTanggalsurat(new Date()); setDari(''); setPengoleh(''); setFilesurat(null); signaturePadReff.current.clear(); }}>RESET FORM</Button>
                    <Button w='100%' colorScheme='blue' mt={4} onClick={() => confAdd()}>INPUT SURAT MASUK</Button>
                  </Box>
                </GridItem>
              </Grid>
            </FormControl>
          </Flex>
        </Flex>
      </Flex>
    </Card>
  );
}
